import { render, staticRenderFns } from "./AgeInput.vue?vue&type=template&id=6de05998&scoped=true"
import script from "./AgeInput.vue?vue&type=script&lang=ts"
export * from "./AgeInput.vue?vue&type=script&lang=ts"
import style0 from "./AgeInput.vue?vue&type=style&index=0&id=6de05998&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de05998",
  null
  
)

export default component.exports